import React, { useState } from 'react'
import { data } from 'react-router'

function Register() {

  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [pwd, setPwd] = useState("")

  const handleAdd = (e) => {
    e.preventDefault();

    fetch(`/users?email=${email}.json`)
    .then((res) => res.json())
    .then((existingUsers) => {
      if (existingUsers.length > 0) {
        alert("This email is already registered. Please use a different one.");
      } 
      else 
      {
        fetch("/users.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            name: name,
            email: email,
            pwd: pwd
          })
        })
        .then((res) => res.json())
        .then((data) => console.log(data))
        // .catch((err) => console.log("Error saving user:", err));
      }
    })}

  return (
    <div>
      <div>
        <div className="page-heading header-text">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                {/* <span className="breadcrumb"><a href="#">Home</a>  /  Register</span> */}
                <h3>Register</h3>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-page section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-7">
                <div className="section-heading">
                  <h6>| Register</h6>
                </div>
              </div>
              <div className="col-lg-8">
                <form onSubmit={handleAdd} id="contact-form" method="post">
                  <div className="row">
                    <div className="col-lg-12">
                      <fieldset>
                        <label htmlFor="name">Name</label>
                        <input type="name" name="name" id="name" placeholder="Your Name..." value={name} onChange={(e)=>{setName(e.target.value)}}/>
                      </fieldset>
                    </div>
                    <div className="col-lg-12">
                      <fieldset>
                        <label htmlFor="email">Email Address</label>
                        <input type="text" name="email" id="email" pattern="[^ @]*@[^ @]*" placeholder="Your E-mail..." value={email} onChange={(e)=>{setEmail(e.target.value)}} />
                      </fieldset>
                    </div>
                    <div className="col-lg-12">
                      <fieldset>
                        <label htmlFor="pwd">Password</label>
                        <input type="password" placeholder="Password..." value={pwd} onChange={(e)=>{setPwd(e.target.value)}} />
                      </fieldset>
                    </div>
                    <div className="col-lg-8">
                      <fieldset>
                        <button type="submit" id="form-submit" className="orange-button">Register</button>
                      </fieldset>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default Register